import React, { useEffect, useState } from "react";
import { BaseModal } from "@/react/components/editors/base/BaseModal";
import { BaseModalBody } from "@/react/components/editors/base/BaseModalBody";
import { Input } from "@/modern/components/ui/input";
import { Label } from "@/modern/components/ui/label";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { GRANTS } from "@/other/constants/PrivilegeTypes";
import { ViewOrganizerList } from "./components/ViewOrganizerList";

interface ViewOrganizerEditorProps {
  record: {
    folderRecord: any;
    [key: string]: any;
  };
  onClose: () => void;
  editorInstance?: any;
  context?: any;
}

export const ViewOrganizerEditor = ({ record, onClose, editorInstance, context: contextProp }: ViewOrganizerEditorProps) => {
  const context = useSwivuBryntumContext();
  const { project, user, editorHandler, viewManager } = contextProp || context;
  const [folderName, setFolderName] = useState(record?.folderRecord?.name || "");
  const [views, setViews] = useState<any[]>([]);

  useEffect(() => {
    if (!record) return;

    const isAdmin = user.can(GRANTS.grant_one);
    const filteredViews = project.viewsStore.query((view: any) => {
      return view.folderId === record.folderRecord.id && (isAdmin || view.isDefaultView || view.isShareToHQ || view.isOwnView);
    }, true).sort((a: any, b: any) => a.order - b.order);

    setViews(filteredViews);
  }, [record, project, user]);

  const handleFolderNameChange = (value: string) => {
    setFolderName(value);
    const { folderRecord } = record;
    if (folderRecord && user.can(GRANTS.grant_one)) {
      folderRecord.name = value;
    }
  };

  const handleReorder = (reorderedViews: any[]) => {
    // Update order property for each view
    reorderedViews.forEach((view, index) => {
      view.order = index;
    });
    setViews(reorderedViews);
  };

  const handleDelete = (viewToDelete: any) => {
    viewManager.deleteView(viewToDelete);
    setViews((prevViews) => prevViews.filter((v) => v.id !== viewToDelete.id));
  };

  const handleToggleVisibility = (view: any) => {
    view.isVisible = !view.isVisible;
    setViews([...views]);
  };

  const isAdmin = user.can(GRANTS.grant_one);

  return (
    <BaseModal
      record={record}
      onClose={onClose}
      title="Views Manager"
      description=""
      editorInstance={editorInstance}
      hideMenu={true}
      size={{
        width: "35em",
        height: "min(100vh, 600px)",
        maxHeight: "100vh",
        maxWidth: "100vw",
        minWidth: "400px",
        minHeight: "600px"
      }}
      modal={false}
      version={undefined}
      swivuAssistanceConfig={undefined}
      headerIconCls=""
    >
      <BaseModalBody className="flex flex-col gap-4 p-4">
        <div className="flex flex-col gap-2">
          <Label htmlFor="folder-name">Column Name</Label>
          <Input
            id="folder-name"
            value={folderName}
            onChange={(e) => handleFolderNameChange(e.target.value)}
            placeholder="Column Name"
            disabled={!isAdmin}
          />
        </div>

        <div className="flex-1 overflow-auto">
          <ViewOrganizerList
            views={views}
            project={project}
            user={user}
            editorHandler={editorHandler}
            viewManager={viewManager}
            canEdit={isAdmin}
            onReorder={handleReorder}
            onDelete={handleDelete}
            onToggleVisibility={handleToggleVisibility}
          />
        </div>
      </BaseModalBody>
    </BaseModal>
  );
};
